import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import { isStringNumber } from 'assets/utils/parsersAndValidation/Validators';
import Tier from 'models/productManagement/tier/Model.Tier';
import { useVehicleMakeProvider } from '../VehicleMake.Hooks';

export default function VehicleMakeEdit() {
  const { lang } = getLocales();
  const { selected, pageRouter, saveApi } = useVehicleMakeProvider();
  const { payload: tiersPayload } = useApi({ action: Tier.list });

  return (
    <ModalForm<Api.Core.VehicleMake.Save.IRequest>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.vehicleMake}
      default={selected?.toJSON() || {}}
      onCancel={pageRouter.updateParams}
      onSubmit={(data) => saveApi.execute(data)}
      validation={(data, errors) => {
        if (!data.makeCode) errors.makeCode = lang.mustNotBeEmpty;
      }}
      render={({ form }) => (
        <FormWrapper>
          <TextInput
            name="makeCode"
            label={lang.make}
            value={form.data.makeCode}
            error={form.errors.makeCode}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
          <TextInput
            name="alternativeMakeCode"
            label={lang.alternativeMakeCode}
            value={form.data.alternativeMakeCode}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
          <SelectInput
            name="tierId"
            label={lang.tiers}
            data={tiersPayload?.data?.map((it) => it.displayInfo)}
            value={form.data.tiers?.map((it) => it.id)}
            error={form.errors.tiers?._objectError}
            isMultiselect
            onChange={({ tierId }) =>
              form.update({
                tiers: tierId
                  .map((it) => tiersPayload?.data?.find((d) => d.id === it))
                  ?.filter((it) => (it ? true : false)),
              })
            }
            icon={<Icon class="fas-globe" />}
          />
          <InputWrapper>
            <TextInput
              name="mfgPowertrainWarrantyMonths"
              label={lang.mfgPowertrainWarrantyMonths}
              value={form.data.mfgPowertrainWarrantyMonths}
              onChange={(input) =>
                form.update({
                  mfgPowertrainWarrantyMonths: isStringNumber(input.mfgPowertrainWarrantyMonths)
                    ? input.mfgPowertrainWarrantyMonths
                    : form.data.mfgPowertrainWarrantyMonths,
                })
              }
              icon={<Icon class="if-quill-pen" />}
            />
            <TextInput
              name="mfgPowertrainWarrantyKm"
              label={lang.mfgPowertrainWarrantyKm}
              value={form.data.mfgPowertrainWarrantyKm}
              onChange={(input) =>
                form.update({
                  mfgPowertrainWarrantyKm: isStringNumber(input.mfgPowertrainWarrantyKm)
                    ? input.mfgPowertrainWarrantyKm
                    : form.data.mfgPowertrainWarrantyKm,
                })
              }
              icon={<Icon class="if-quill-pen" />}
            />
          </InputWrapper>
          <InputWrapper>
            <TextInput
              name="mfgWholeVehicleWarrantyMonths"
              label={lang.mfgWholeVehicleWarrantyMonths}
              value={form.data.mfgWholeVehicleWarrantyMonths}
              onChange={(input) =>
                form.update({
                  mfgWholeVehicleWarrantyMonths: isStringNumber(input.mfgWholeVehicleWarrantyMonths)
                    ? input.mfgWholeVehicleWarrantyMonths
                    : form.data.mfgWholeVehicleWarrantyMonths,
                })
              }
              icon={<Icon class="if-quill-pen" />}
            />
            <TextInput
              name="mfgWholeVehicleWarrantyKm"
              label={lang.mfgWholeVehicleWarrantyKm}
              value={form.data.mfgWholeVehicleWarrantyKm}
              onChange={(input) =>
                form.update({
                  mfgWholeVehicleWarrantyKm: isStringNumber(input.mfgWholeVehicleWarrantyKm)
                    ? input.mfgWholeVehicleWarrantyKm
                    : form.data.mfgWholeVehicleWarrantyKm,
                })
              }
              icon={<Icon class="if-quill-pen" />}
            />
          </InputWrapper>
        </FormWrapper>
      )}
    />
  );
}
